import { UploadFileProps } from "../entities/uploadFile";
import { ChatRepository } from "../repositories/ChatRepository";

export class UploadFile {
	constructor(private repository: ChatRepository) {}

	execute(params: UploadFileParams): Promise<void> {
		return this.repository.uploadFile(params.params);
	}
}
export class UploadFileParams {
	constructor(public params: UploadFileProps) {}
}
